module.exports = __webpack_public_path__ + "static/img/m_ol4.c7778a2.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/m_ol4.jpg
// module id = x+je
// module chunks = 0